import { Guid } from '@/utils/guid'
import { getFormatMessage } from '@/utils/utils'
import { Select } from 'antd'
import React from 'react'
import { ReactNode } from 'react'
import { SelectItem } from './SelectItem'

const formatMessage = getFormatMessage()

/**
 * 盒子类型
 * 0:FBox
 * 1:FBox-Mini
 * 2:FBox-Lite
 * 3:FBox-Vpn
 * 4:FBox-Lite_T
 * 5:FLink
 * 6:FL3
 * 7:FBox-Lite-New
 * 8:HMI
 */
export const boxTypeItems: SelectItem[] = [
  { value: 0, text: formatMessage({ id: 'app.boxType.0' }) },
  { value: 1, text: formatMessage({ id: 'app.boxType.1' }) },
  { value: 2, text: formatMessage({ id: 'app.boxType.2' }) },
  { value: 3, text: formatMessage({ id: 'app.boxType.3' }) },
  { value: 4, text: formatMessage({ id: 'app.boxType.4' }) },
  { value: 5, text: formatMessage({ id: 'app.boxType.5' }) },
  { value: 6, text: formatMessage({ id: 'app.boxType.6' }) },
  { value: 7, text: formatMessage({ id: 'app.boxType.7' }) },
  { value: 8, text: formatMessage({ id: 'app.boxType.8' }) }
  // { value: 16, text: formatMessage({ id: 'app.boxType.16' }) }
]

export const boxTypeFilterItems: SelectItem[] = [
  { value: 0, text: formatMessage({ id: 'app.boxType.0' }) },
  { value: 1, text: formatMessage({ id: 'app.boxType.1' }) },
  { value: 999, text: formatMessage({ id: 'app.boxType.2' }) }, // 999为虚拟类型(包括: 2,4,7 均为Lite)
  { value: 3, text: formatMessage({ id: 'app.boxType.3' }) },
  { value: 5, text: formatMessage({ id: 'app.boxType.5' }) },
  { value: 6, text: formatMessage({ id: 'app.boxType.6' }) },
  { value: 8, text: formatMessage({ id: 'app.boxType.8' }) }
]

export const workModeItems: SelectItem[] = [
  { value: 0, text: 'RS232' },
  { value: 1, text: 'RS485_4W' },
  { value: 2, text: 'RS485_2W' }
]

export const baudRateItems: SelectItem[] = [
  { value: 110, text: '110' },
  { value: 300, text: '300' },
  { value: 600, text: '600' },
  { value: 1200, text: '1200' },
  { value: 2400, text: '2400' },
  { value: 4800, text: '4800' },
  { value: 9600, text: '9600' },
  { value: 14400, text: '14400' },
  { value: 19200, text: '19200' },
  { value: 38400, text: '38400' },
  { value: 56000, text: '56000' },
  { value: 57600, text: '57600' },
  { value: 76800, text: '76800' },
  { value: 115200, text: '115200' },
  { value: 187500, text: '187500' }
]

export const dataBitItems: SelectItem[] = [
  { value: 7, text: '7' },
  { value: 8, text: '8' }
]

export const stopBitItems: SelectItem[] = [
  { value: 1, text: '1' },
  { value: 2, text: '2' }
]

export const parityItems: SelectItem[] = [
  { value: 0, text: formatMessage({ id: 'app.parity.0' }) },
  { value: 1, text: formatMessage({ id: 'app.parity.1' }) },
  { value: 2, text: formatMessage({ id: 'app.parity.2' }) }
]

export const plcTypeItems: SelectItem[] = [
  { value: 'serial', text: formatMessage({ id: 'app.plcType.serial' }) },
  { value: 'ethernet', text: formatMessage({ id: 'app.plcType.ethernet' }) },
  { value: 'local', text: formatMessage({ id: 'app.plcType.local' }) }
]

export const portNoItems: SelectItem[] = [
  { value: 0, text: formatMessage({ id: 'app.portNo.0' }) },
  { value: 1, text: formatMessage({ id: 'app.portNo.1' }) },
  { value: 2, text: formatMessage({ id: 'app.portNo.2' }) }
]

export const deviceModeItems: SelectItem[] = [
  { value: 0, text: formatMessage({ id: 'app.deviceMode.0' }) },
  { value: 1, text: formatMessage({ id: 'app.deviceMode.1' }) }
]

export const variableDataType: {
  [key: number]: {
    text: string
    value: number
    width: number
  }
} = {
  0: {
    text: formatMessage({ id: 'app.dataType.0' }),
    value: 0,
    width: 0
  },
  1: {
    text: formatMessage({ id: 'app.dataType.1' }),
    value: 1,
    width: 2
  },
  2: {
    text: formatMessage({ id: 'app.dataType.2' }),
    value: 2,
    width: 2
  },
  11: {
    text: formatMessage({ id: 'app.dataType.11' }),
    value: 11,
    width: 4
  },
  12: {
    text: formatMessage({ id: 'app.dataType.12' }),
    value: 12,
    width: 4
  },
  3: {
    text: formatMessage({ id: 'app.dataType.3' }),
    value: 3,
    width: 2
  },
  13: {
    text: formatMessage({ id: 'app.dataType.13' }),
    value: 13,
    width: 4
  },
  16: {
    text: formatMessage({ id: 'app.dataType.16' }),
    value: 16,
    width: 4
  },
  4: {
    text: formatMessage({ id: 'app.dataType.4' }),
    value: 4,
    width: 2
  },
  14: {
    text: formatMessage({ id: 'app.dataType.14' }),
    value: 14,
    width: 4
  },
  5: {
    text: formatMessage({ id: 'app.dataType.5' }),
    value: 5,
    width: 2
  },
  15: {
    text: formatMessage({ id: 'app.dataType.15' }),
    value: 15,
    width: 4
  },
  30: {
    text: formatMessage({ id: 'app.dataType.30' }),
    value: 30,
    width: 4
  }
}

/**
 * 数据类型
 * 0: 位
 * 1: 16位无符号
 * 2: 16位有符号
 * 3: 16位BCD
 * 4: 16位16进制
 * 5: 16位二进制
 * 11: 32位无符号
 * 12: 32位有符号
 * 13: 32位BCD
 * 14: 32位16进制
 * 15: 32位二进制
 * 16: 单精度浮点
 * 30: 字符串
 */
export const dataTypeItems: SelectItem[] = [
  variableDataType[0],
  variableDataType[1],
  variableDataType[2],
  variableDataType[11],
  variableDataType[12],
  variableDataType[3],
  variableDataType[13],
  variableDataType[16],
  variableDataType[4],
  variableDataType[14],
  variableDataType[5],
  variableDataType[15],
  variableDataType[30]
]

/**
 * 数据类型的范围
 */
export const dataTypeRange: {
  [key: number]: {
    maxValueLimit: number
    minValueLimit: number
    maxBitNum: number
  }
} = {
  0: {
    maxValueLimit: 1,
    minValueLimit: 0,
    maxBitNum: 2
  },
  5: {
    maxValueLimit: 65535,
    minValueLimit: 0,
    maxBitNum: 2
  },
  15: {
    maxValueLimit: 4294967295,
    minValueLimit: 0,
    maxBitNum: 2
  },
  1: {
    maxValueLimit: 65535,
    minValueLimit: 0,
    maxBitNum: 10
  },
  2: {
    maxValueLimit: 32767,
    minValueLimit: -32768,
    maxBitNum: 10
  },
  3: {
    maxValueLimit: 9999,
    minValueLimit: 0,
    maxBitNum: 10
  },
  13: {
    maxValueLimit: 99999999,
    minValueLimit: 0,
    maxBitNum: 10
  },
  11: {
    maxValueLimit: 4294967295,
    minValueLimit: 0,
    maxBitNum: 10
  },
  12: {
    maxValueLimit: 2147483647,
    minValueLimit: -2147483648,
    maxBitNum: 10
  },
  16: {
    maxValueLimit: 1000000000,
    minValueLimit: -1000000000,
    maxBitNum: 10
  },
  4: {
    maxValueLimit: 65535,
    minValueLimit: 0,
    maxBitNum: 16
  },
  14: {
    maxValueLimit: 4294967295,
    minValueLimit: 0,
    maxBitNum: 16
  }
}

export const dataValidateRegex = {
  4: new RegExp(/^[0-9a-fA-F]{1,4}$/g),
  14: new RegExp(/^[0-9a-fA-F]{1,8}$/g),
  5: new RegExp(/^[0-1]{1,16}$/g),
  15: new RegExp(/^[0-1]{1,32}$/g)
}

/**
 * 支持浮点数的数据类型
 */
export const decimalDataType: number[] = [1, 2, 3, 11, 12, 13, 16]

/**
 * 位数据类型
 */
export const bitDataType: number[] = [0]

/**
 * 16进制数据类型
 */
export const hexDataType: number[] = [4, 14]

/**
 * 二进制数据类型
 */
export const binaryDataType: number[] = [5, 15]

/**
 * BCD码数据类型
 */
export const bcdDataType: number[] = [3, 13]

/**
 * 不支持单位的数据类型
 */
export const noneUnitDataType: number[] = [0, 30]

/** 不支持小数位数的数据类型 */
export const noneDigitsDataType: number[] = [0, 4, 5, 14, 15, 30]

/**
 * 支持死区的数据类型
 */
export const deadZoneDataType: number[] = [1, 11, 2, 12, 3, 13, 16]

/**
 * 支持字符串的数据类型
 */
export const stringDataType: number[] = [30]

/**
 * 支持按位索引的数据类型
 */
export const bitIndexDataType: number[] = [1, 11, 2, 12, 3, 13, 4, 14, 5, 15]

/**
 * 支持边缘换算的数据类型
 */
export const transformDataType: number[] = [1, 11, 2, 12, 3, 13, 16]

/**
 * 16位整数高低字节序
 */
export const byteOrder16Items: SelectItem[] = [
  { value: 0, text: '21' },
  { value: 1, text: '12' }
]

/**
 * 32位整数高低字节序
 */
export const byteOrder32Items: SelectItem[] = [
  { value: 0, text: '4321' },
  { value: 1, text: '4312' },
  { value: 2, text: '2143' },
  { value: 3, text: '1234' }
]

/**
 * 32位浮点数高低字节序
 */
export const byteOrderFloatItems: SelectItem[] = [
  { value: 0, text: '4321' },
  { value: 1, text: '4312' },
  { value: 2, text: '2143' },
  { value: 3, text: '1234' }
]

export const mqttVersionItems: SelectItem[] = [
  { value: '5.0', text: '5.0' },
  { value: '3.1.1', text: '3.1.1' },
  { value: '3.1', text: '3.1' }
]

export const stringDataEncodingItems: SelectItem[] = [
  { value: 1, text: 'Unicode' },
  { value: 2, text: 'ASCII' }
]

export const mqttPubModeItems: SelectItem[] = [
  {
    value: 'interval',
    text: formatMessage({ id: 'app.mqtt.pubMode.interval' })
  },
  {
    value: 'change',
    text: formatMessage({ id: 'app.mqtt.pubMode.changed' })
  }
]

export const mqttIntervalUnitItems: SelectItem[] = [
  { value: 's', text: 's' },
  { value: 'ms', text: 'ms' }
]

export const mqttWebSocketConns: string[] = [
  'raw_websocket',
  'secure_websocket'
]

export const mqttSecureConns: string[] = ['secure_tcp', 'secure_websocket']

export const mqttConnectionTypeItems: SelectItem[] = [
  {
    value: 'raw_tcp',
    text: formatMessage({ id: 'app.mqtt.connectionType.raw_tcp' })
  },
  {
    value: 'secure_tcp',
    text: formatMessage({ id: 'app.mqtt.connectionType.secure_tcp' })
  },
  {
    value: 'raw_websocket',
    text: formatMessage({ id: 'app.mqtt.connectionType.raw_websocket' })
  },
  {
    value: 'secure_websocket',
    text: formatMessage({ id: 'app.mqtt.connectionType.secure_websocket' })
  }
]

export const mqttStoreTypeItems: SelectItem[] = [
  {
    value: 'local',
    text: formatMessage({ id: 'app.mqtt.connectionType.local' })
  },
  {
    value: 'sd',
    text: formatMessage({ id: 'app.mqtt.connectionType.sd' })
  },
  {
    value: 'usb',
    text: formatMessage({ id: 'app.mqtt.connectionType.usb' })
  }
]

export const mqttValueType = {
  integer: {
    value: 'integer',
    text: 'int'
  },
  unsigned_integer: {
    value: 'unsigned_integer',
    text: 'uint'
  },
  float: {
    value: 'float',
    text: 'float'
  },
  double: {
    value: 'double',
    text: 'double'
  },
  long: {
    value: 'long',
    text: 'long'
  },
  string: {
    value: 'string',
    text: 'string'
  },
  boolean: {
    value: 'boolean',
    text: 'boolean'
  },
  array: {
    value: 'array',
    text: 'array'
  },
  object: {
    value: 'object',
    text: 'object'
  },
  bcd_code: {
    value: 'bcd_code',
    text: 'bcd_code'
  },
  hex_code: {
    value: 'hex_code',
    text: 'hex_code'
  },
  bin_code: {
    value: 'bin_code',
    text: 'bin_code'
  }
}

export const mqttObjectTypes = [
  mqttValueType.array.value,
  mqttValueType.object.value
]

export const mqttValueTypeItems: SelectItem[] = [
  mqttValueType.integer,
  mqttValueType.long,
  mqttValueType.unsigned_integer,
  mqttValueType.float,
  mqttValueType.double,
  mqttValueType.string,
  mqttValueType.boolean,
  mqttValueType.array,
  mqttValueType.object,
  mqttValueType.bcd_code,
  mqttValueType.hex_code,
  mqttValueType.bin_code
]

/**
 * 0: 位
 * 1: 16位无符号
 * 2: 16位有符号
 * 3: 16位BCD
 * 4: 16位16进制
 * 5: 16位二进制
 * 11: 32位无符号
 * 12: 32位有符号
 * 13: 32位BCD
 * 14: 32位16进制
 * 15: 32位二进制
 * 16: 单精度浮点
 * 30: 字符串
 * 0-30: 监控点变量类型对应MQTT变量类型
 * 990-999：内置变量类型对应MQTT变量类型
 */
export const mqttVariableType: { [key: number]: SelectItem[] } = {
  0: [mqttValueType.boolean, mqttValueType.string],
  1: [
    mqttValueType.integer,
    mqttValueType.unsigned_integer,
    mqttValueType.float,
    mqttValueType.double,
    mqttValueType.string
  ],
  2: [
    mqttValueType.integer,
    mqttValueType.unsigned_integer,
    mqttValueType.float,
    mqttValueType.double,
    mqttValueType.string
  ],
  11: [
    mqttValueType.integer,
    mqttValueType.unsigned_integer,
    mqttValueType.float,
    mqttValueType.double,
    mqttValueType.string
  ],
  12: [
    mqttValueType.integer,
    mqttValueType.unsigned_integer,
    mqttValueType.float,
    mqttValueType.double,
    mqttValueType.string
  ],
  3: [
    mqttValueType.integer,
    mqttValueType.bcd_code,
    mqttValueType.unsigned_integer,
    mqttValueType.string
  ],
  13: [
    mqttValueType.integer,
    mqttValueType.bcd_code,
    mqttValueType.unsigned_integer,
    mqttValueType.string
  ],
  16: [mqttValueType.float, mqttValueType.double, mqttValueType.string],
  4: [
    mqttValueType.integer,
    mqttValueType.hex_code,
    mqttValueType.unsigned_integer,
    mqttValueType.string
  ],
  14: [
    mqttValueType.integer,
    mqttValueType.hex_code,
    mqttValueType.unsigned_integer,
    mqttValueType.string
  ],
  5: [
    mqttValueType.integer,
    mqttValueType.bin_code,
    mqttValueType.unsigned_integer,
    mqttValueType.string
  ],
  15: [
    mqttValueType.integer,
    mqttValueType.bin_code,
    mqttValueType.unsigned_integer,
    mqttValueType.string
  ],
  30: [mqttValueType.string],
  999: [mqttValueType.long, mqttValueType.string],
  998: [mqttValueType.integer, mqttValueType.string],
  997: [mqttValueType.unsigned_integer, mqttValueType.string],
  996: [mqttValueType.float, mqttValueType.string],
  995: [mqttValueType.string],
  994: [mqttValueType.unsigned_integer],
  993: [mqttValueType.integer],
  992: [mqttValueType.boolean],
  991: [mqttValueType.string, mqttValueType.integer]
}

/**
 * MQTT数据类型默认值
 */
export const mqttVariableDefaultType = {
  0: mqttValueType.boolean,
  1: mqttValueType.unsigned_integer,
  2: mqttValueType.integer,
  11: mqttValueType.unsigned_integer,
  12: mqttValueType.integer,
  3: mqttValueType.bcd_code,
  13: mqttValueType.bcd_code,
  16: mqttValueType.float,
  4: mqttValueType.hex_code,
  14: mqttValueType.hex_code,
  5: mqttValueType.bin_code,
  15: mqttValueType.bin_code,
  30: mqttValueType.string
}

/**
 * 数据转发MQTT功能列表
 */
export const mqttFunctionItems: SelectItem[] = [
  {
    value: 'PushMonitorData',
    text: formatMessage({ id: 'app.mqtt.function.PushMonitorData' })
  },
  {
    value: 'PushAlarm',
    text: formatMessage({ id: 'app.mqtt.function.PushAlarm' })
  },
  {
    value: 'WriteItem',
    text: formatMessage({ id: 'app.mqtt.function.WriteItem' })
  },
  {
    value: 'Suspend',
    text: formatMessage({ id: 'app.mqtt.function.Suspend' })
  },
  {
    value: 'SetReboot',
    text: formatMessage({ id: 'app.mqtt.function.SetReboot' })
  },
  {
    value: 'SetPushMethod',
    text: formatMessage({ id: 'app.mqtt.function.SetPushMethod' })
  },
  {
    value: 'ReadItem',
    text: formatMessage({ id: 'app.mqtt.function.ReadItem' })
  },
  {
    value: 'GetFBoxInfo',
    text: formatMessage({ id: 'app.mqtt.function.GetFBoxInfo' })
  },
  {
    value: 'GetPicture',
    text: formatMessage({ id: 'app.mqtt.function.GetPicture' })
  }
  // {
  //   value: 'PushRegisterMsg',
  //   text: formatMessage({ id: 'app.mqtt.function.PushRegisterMsg' })
  // },
  // todo: 经验证下发低版本盒子 北向无法启动，需要特性屏蔽
  // {
  //   value: 'PushAlarmEvent',
  //   text: formatMessage({ id: 'app.mqtt.function.PushAlarmEvent' })
  // }
]

export const mqttServerTypeItems: SelectItem[] = [
  { value: 'emqx', text: 'EMQX' }
]

export const mqttApiVersionItems: SelectItem[] = [
  { value: 'v4', text: 'v4' },
  { value: 'v3', text: 'v3' }
]

export const timezoneItems: SelectItem[] = [
  { value: 'utc', text: 'Default(UTC)' },
  { value: 'asia/shanghai', text: 'Asia/Shanghai' }
]

export const connectionModeItems: SelectItem[] = [
  { value: 'mqtt', text: 'SE' },
  { value: 'tcp', text: 'Hub' }
]

export const mqttConnectionTypes = [
  { value: 'tcp://', text: 'tcp://' },
  { value: 'ssl://', text: 'ssl://' },
  { value: 'ws://', text: 'ws://' },
  { value: 'wss://', text: 'wss://' }
]

/**
 * 报警触发条件
 * 0:不等于, 1:等于, 2:大于 3:大于等于 4:小于 5:小于等于
 */
export const alarmConditionItems: SelectItem[] = [
  { value: 1, text: formatMessage({ id: 'app.template.alarm.condition.1' }) },
  { value: 0, text: formatMessage({ id: 'app.template.alarm.condition.0' }) },
  { value: 2, text: formatMessage({ id: 'app.template.alarm.condition.2' }) },
  { value: 3, text: formatMessage({ id: 'app.template.alarm.condition.3' }) },
  { value: 4, text: formatMessage({ id: 'app.template.alarm.condition.4' }) },
  { value: 5, text: formatMessage({ id: 'app.template.alarm.condition.5' }) }
]

/**
 * 报警条件关系运算符
 * 0:None, 1:And 2:Or
 */
export const alarmCondMethodItems: SelectItem[] = [
  {
    value: 0,
    text: formatMessage({ id: 'app.template.alarm.conditionMethod.0' })
  },
  {
    value: 1,
    text: formatMessage({ id: 'app.template.alarm.conditionMethod.1' })
  },
  {
    value: 2,
    text: formatMessage({ id: 'app.template.alarm.conditionMethod.2' })
  }
]

/**
 * NTP授时服务器列表
 */
export const ntpServerItems: SelectItem[] = [
  { value: '', text: '自定义NTP服务器' },
  { value: 'time.fbox360.net', text: '繁易公共NTP服务器' },
  { value: 'ntp.ntsc.ac.cn', text: '国家授时中心NTP服务器' },
  { value: 'cn.ntp.org.cn', text: '中国NTP快速授时服务' },
  { value: 'cn.pool.ntp.org', text: '国际NTP快速授时服务中国片区' },
  { value: 'ntp1.aliyun.com', text: '阿里云公共NTP服务器' },
  { value: 'time1.cloud.tencent.com', text: '腾讯公共NTP服务器' },
  { value: 'hk.ntp.org.cn', text: '中国香港NTP服务器' },
  { value: 'pool.ntp.org', text: '全球NTP授时服务器' },
  { value: 'time.cloudflare.com', text: 'CloudFlare NTP授时服务器' },
  { value: 'time.google.com', text: '谷歌公共NTP服务器' },
  { value: 'time.apple.com', text: '苹果公共NTP服务器' },
  { value: 'time.windows.com', text: '微软Windows NTP服务器' },
  { value: 'us.ntp.org.cn', text: '美国NTP授时服务器' },
  { value: 'jp.ntp.org.cn', text: '日本NTP授时服务器' },
  { value: 'sgp.ntp.org.cn', text: '新加坡NTP授时服务器' }
]

/**
 * 设备默认导入方式
 */
export const boxImportTypes: SelectItem[] = [
  { value: 0, text: 'USB查找' },
  { value: 1, text: '广播搜索' },
  { value: 2, text: '固定IP搜索' },
  { value: 3, text: '文件导入' },
  { value: 4, text: '标签导入' }
]

/**
 * 日志级别
 */
export const logLevelItems: SelectItem[] = [
  { value: 'information', text: '信息' },
  { value: 'warning', text: '警告' },
  { value: 'error', text: '错误' },
  { value: 'fatal', text: '致命' }
]

export const compressionItems: SelectItem[] = [
  { value: 'brotli', text: 'brotli' }
]

export const sysTimezoneItems: SelectItem[] = [
  { value: 'Africa/Brazzaville', text: 'Africa/Brazzaville' },
  { value: 'Africa/Cairo', text: 'Africa/Cairo' },
  { value: 'Africa/Casablanca', text: 'Africa/Casablanca' },
  { value: 'Africa/Harare', text: 'Africa/Harare' },
  { value: 'Africa/Nairobi', text: 'Africa/Nairobi' },
  { value: 'America/Anchorage', text: 'America/Anchorage' },
  {
    value: 'America/Argentina/Buenos_Aires',
    text: 'America/Argentina/Buenos_Aires'
  },
  { value: 'America/Barbados', text: 'America/Barbados' },
  { value: 'America/Bogota', text: 'America/Bogota' },
  { value: 'America/Caracas', text: 'America/Caracas' },
  { value: 'America/Chihuahua', text: 'America/Chihuahua' },
  { value: 'America/Costa_Rica', text: 'America/Costa_Rica' },
  { value: 'America/Denver', text: 'America/Denver' },
  { value: 'America/Godthab', text: 'America/Godthab' },
  { value: 'America/Los_Angeles', text: 'America/Los_Angeles' },
  { value: 'America/Manaus', text: 'America/Manaus' },
  { value: 'America/Mexico', text: 'America/Mexico' },
  { value: 'America/Montevideo', text: 'America/Montevideo' },
  { value: 'America/New_York', text: 'America/New_York' },
  { value: 'America/Phoenix', text: 'America/Phoenix' },
  { value: 'America/Regina', text: 'America/Regina' },
  { value: 'America/Santiago', text: 'America/Santiago' },
  { value: 'America/Sao_Paulo', text: 'America/Sao_Paulo' },
  { value: 'America/St_Johns', text: 'America/St_Johns' },
  { value: 'America/Tijuana', text: 'America/Tijuana' },
  { value: 'Asia/Almaty', text: 'Asia/Almaty' },
  { value: 'Asia/Amman', text: 'Asia/Amman' },
  { value: 'Asia/Baghdad', text: 'Asia/Baghdad' },
  { value: 'Asia/Baku', text: 'Asia/Baku' },
  { value: 'Asia/Bangkok', text: 'Asia/Bangkok' },
  { value: 'Asia/Beirut', text: 'Asia/Beirut' },
  { value: 'Asia/Calcutta', text: 'Asia/Calcutta' },
  { value: 'Asia/Colombo', text: 'Asia/Colombo' },
  { value: 'Asia/Dubai', text: 'Asia/Dubai' },
  { value: 'Asia/Hong_Kong', text: 'Asia/Hong_Kong' },
  { value: 'Asia/Irkutsk', text: 'Asia/Irkutsk' },
  { value: 'Asia/Jerusalem', text: 'Asia/Jerusalem' },
  { value: 'Asia/Kabul', text: 'Asia/Kabul' },
  { value: 'Asia/Karachi', text: 'Asia/Karachi' },
  { value: 'Asia/Katmandu', text: 'Asia/Katmandu' },
  { value: 'Asia/Krasnoyarsk', text: 'Asia/Krasnoyarsk' },
  { value: 'Asia/Kuala_Lumpur', text: 'Asia/Kuala_Lumpur' },
  { value: 'Asia/Kuwait', text: 'Asia/Kuwait' },
  { value: 'Asia/Magadan', text: 'Asia/Magadan' },
  { value: 'Asia/Oral', text: 'Asia/Oral' },
  { value: 'Asia/Rangoon', text: 'Asia/Rangoon' },
  { value: 'Asia/Seoul', text: 'Asia/Seoul' },
  { value: 'Asia/Shanghai', text: 'Asia/Shanghai' },
  { value: 'Asia/Taipei', text: 'Asia/Taipei' },
  { value: 'Asia/Tbilisi', text: 'Asia/Tbilisi' },
  { value: 'Asia/Tehran', text: 'Asia/Tehran' },
  { value: 'Asia/Tokyo', text: 'Asia/Tokyo' },
  { value: 'Asia/Vladivostok', text: 'Asia/Vladivostok' },
  { value: 'Asia/Yakutsk', text: 'Asia/Yakutsk' },
  { value: 'Asia/Yekaterinburg', text: 'Asia/Yekaterinburg' },
  { value: 'Asia/Yerevan', text: 'Asia/Yerevan' },
  { value: 'Atlantic/Azores', text: 'Atlantic/Azores' },
  { value: 'Atlantic/Cape_Verde', text: 'Atlantic/Cape_Verde' },
  { value: 'Atlantic/South_Georgia', text: 'Atlantic/South_Georgia' },
  { value: 'Australia/Adelaide', text: 'Australia/Adelaide' },
  { value: 'Australia/Brisbane', text: 'Australia/Brisbane' },
  { value: 'Australia/Darwin', text: 'Australia/Darwin' },
  { value: 'Australia/Hobart', text: 'Australia/Hobart' },
  { value: 'Australia/Perth', text: 'Australia/Perth' },
  { value: 'Australia/Sydney', text: 'Australia/Sydney' },
  { value: 'Europe/Amsterdam', text: 'Europe/Amsterdam' },
  { value: 'Europe/Athens', text: 'Europe/Athens' },
  { value: 'Europe/Belgrade', text: 'Europe/Belgrade' },
  { value: 'Europe/Brussels', text: 'Europe/Brussels' },
  { value: 'Europe/Helsinki', text: 'Europe/Helsinki' },
  { value: 'Europe/London', text: 'Europe/London' },
  { value: 'Europe/Minsk', text: 'Europe/Minsk' },
  { value: 'Europe/Moscow', text: 'Europe/Moscow' },
  { value: 'Europe/Sarajevo', text: 'Europe/Sarajevo' },
  { value: 'Pacific/Auckland', text: 'Pacific/Auckland' },
  { value: 'Pacific/Fiji', text: 'Pacific/Fiji' },
  { value: 'Pacific/Guam', text: 'Pacific/Guam' },
  { value: 'Pacific/Honolulu', text: 'Pacific/Honolulu' },
  { value: 'Pacific/Majuro', text: 'Pacific/Majuro' },
  { value: 'Pacific/Midway', text: 'Pacific/Midway' },
  { value: 'Pacific/Tongatapu', text: 'Pacific/Tongatapu' },
  { value: 'UTC+08:00', text: 'UTC+08:00' }
]

export function getMqttValueType(key: number): ReactNode[] {
  return getOptions(mqttVariableType[key])
}

export function getOptions(items: SelectItem[]): ReactNode[] {
  return items.map((item) => (
    <Select.Option key={Guid.raw()} value={item.value}>
      {item.text}
    </Select.Option>
  ))
}
